import * as url from "../url.helper";

import { post } from "../api.helper";

export const callGetQuery = data => post(url.GET_QUERY, data);

export const callGetQueryForCustomers = data => post(url.GET_QUERY_CUSTOMERS, data);

export const callGetQueryByEntity = data => post(url.GET_QUERY_ENTITY, data);

export const callAddQuery = data => post(url.ADD_QUERY, data);

export const callDealEsign = data => post(url.DEAL_ESIGN, data);

export const callDealEsignMou = data => post(url.DEAL_MOU_SIGN, data);

export const callUpdateQuery = data => post(url.UPDATE_QUERY, data);

export const callDeleteQuery = data => post(url.DELETE_QUERY, data);

export const callGetFile = data => post(url.GET_FILE, data);

export const downloadDealInfo = data => post(url.DOWNLOAD_DEAL_PDF, data);

